import { createFileRoute } from '@tanstack/react-router'

import { CartPage } from '@/pages/cart/cartPage'

export const Route = createFileRoute('/cart')({
	component: CartPage,
})
